import React, { Component } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';
import get from 'lodash.get';

import Header from '../../components/global/Header';
import Footer from '../../components/global/Footer';
import PhotoGrid from '../../components/grid/PhotoGrid';
import ProgressivePhoto from '../../components/grid/ProgressivePhoto';
import WaldoProductLogo from '../../components/global/WaldoProductLogo';

class PhotoGridView extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    photos: PropTypes.arrayOf(
      PropTypes.shape({
        thumbnail_urls: PropTypes.arrayOf(
          PropTypes.shape({
            url: PropTypes.string,
            width: PropTypes.number,
            height: PropTypes.number,
          }),
        ),
      }),
    ),
    total: PropTypes.number,
    loadMore: PropTypes.func.isRequired,
  };

  state = {
    viewer: true,
  };

  render() {
    const { viewer } = this.state;

    const { loading, photos, total, loadMore } = this.props;

    return (
      <div className="wrapper-main">
        <Header>
          <WaldoProductLogo type="rnd" withIcon brandColor />

          <button
            className="d-none"
            onClick={() => {
              this.setState(({ viewer: v }) => ({
                viewer: !v,
              }));
            }}
          >
            Click
          </button>
        </Header>

        <div
          className="d-flex flex-column"
          style={{
            width: '100%',
          }}
        >
          {viewer ? (
            <PhotoGrid
              loading={loading}
              records={photos}
              total={total}
              loadMore={loadMore}
              cellRenderer={({ record: photo }) => {
                return (
                  <ProgressivePhoto
                    progressive
                    thumbnails={photo.thumbnail_urls}
                  />
                );
              }}
            />
          ) : (
            <div>no viewer</div>
          )}
        </div>

        <Footer />
      </div>
    );
  }
}

const Album = gql`
  query album($id: RecordID!, $limit: Int!, $offset: Int!) {
    album(id: $id) {
      id
      photos(slice: { limit: $limit, offset: $offset }) {
        total
        count
        records {
          id
          thumbnail_urls {
            url
            width
            height
            size_code
          }
        }
      }
    }
  }
`;

const withAlbumPhotos = graphql(Album, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumId,
      limit: 100,
      offset: 0,
    },
  }),
  props: ({ data: { album, loading, fetchMore } }) => ({
    loading,
    photos: get(album, 'photos.records'),
    total: get(album, 'photos.total'),
    loadMore() {
      return fetchMore({
        variables: {
          offset: album.photos.count,
          limit: 100,
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          if (!fetchMoreResult) {
            return previousResult;
          }

          const prevCount = previousResult.album.photos.count;
          const nextCount = fetchMoreResult.album.photos.count;

          return {
            ...previousResult,
            album: {
              ...previousResult.album,
              photos: {
                ...previousResult.album.photos,
                count: prevCount + nextCount,
                records: [
                  ...previousResult.album.photos.records,
                  ...fetchMoreResult.album.photos.records,
                ],
              },
            },
          };
        },
      });
    },
  }),
});

export default compose(withRouter, withAlbumPhotos)(PhotoGridView);
